import React, { useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { ChevronLeft } from 'react-bootstrap-icons';
import { sendEmailActivation } from '../api/translate';
import { toastError, toastWarning } from '../util/ToastifyUtil';
import Toastify from '../components/Toastify';
import { useNavigate } from 'react-router-dom';

const UserMigration = () => {
	const navigate = useNavigate();

	const [email, setEmail] = useState('');
	const [message, setMessage] = useState('');
	const [onSubmit, setOnSubmit] = useState(false);

	const handleInputChange = (e:any) => {
		setEmail(e.target.value);
	};

	const handleSubmit = async (e:any) => {
		e.preventDefault();
		setOnSubmit(true);

		if (!email) {
			toastWarning('There was an issue sending the activation email. Please try again later.')
			return;
		}

		try {
			const response = await sendEmailActivation(email);
			if (response.hasError) {
				toastError('There was an issue sending the activation email. Please contact your Language I/O administrator or contact technical support.');
			} else {
				localStorage.setItem('emailSubmittedForActivation', JSON.stringify(true));
				setMessage('Thank you! If you have previously established a Language I/O account, check your email for next steps to transition your login.');
			}
		} catch (e: any) {
			toastError('There was an issue sending the activation email. Please contact your Language I/O administrator or contact technical support.');
		} finally {
			setOnSubmit(false);
		}
	};

	const handleBack = () => {
		navigate('/');
	}

	return (
		<Container>
			<Toastify />
			<Container className="user-migration-container">
				<Row className="justify-content-md-center">
					<Col md="auto">
						{message !== '' && 
							<>
							<p className="user-migration-message">{message}</p>
							<Col md="auto">
								<Row className="justify-content-md-center text-center mt-4"><a href="/"><strong><ChevronLeft />Back to
									Log in </strong></a></Row>
							</Col>
							</>
						}
						{message == '' &&
							<div>
								<h2 className="user-migration-heading">Action Required:</h2>
								<p className="user-migration-description">We recently updated the login system to provide enhanced security
								 that allows you to use a single account to access all of your Language I/O tools. Please enter your email
								address to verify your account.</p>
								<Form onSubmit={handleSubmit}>
									<Form.Group controlId="formEmail" className="user-migration-form-group">
										<Form.Label>Email address</Form.Label>
										<Form.Control
											type="email"
											placeholder="Enter your email"
											value={email}
											onChange={handleInputChange}
											className="user-migration-form-input"
											required
										/>
									</Form.Group>
									<div className="user-migration-button-group">
										<Button type="button" variant="outline-primary" onClick={handleBack} className="user-migration-submit-button">Back to Log in</Button>
										<Button disabled={onSubmit} variant="primary" type="submit" className="user-migration-submit-button">Submit</Button>
									</div>
								</Form>
							</div>
						}
					</Col>
				</Row>
			</Container>
		</Container>
	);
};

export default UserMigration;
